import { WithClassname } from '../../../../types';
import { Server } from '../../../../types/order';
import { UserOutlined } from '@ant-design/icons';
import ClickToCopy from '../../../helpers/ClickToCopy';
import { OrderHelpers } from '../../../../services/utils/order/OrderHelpers';
import OrderPaymentBreakdown from '../../../payment/OrderPaymentBreakdown';
import React from 'react';
import StorePreview from './StorePreview';
import OrderItemsList from '../../../basket/OrderItemsList';
import OrderMethodIcon from '../../../../assets/icons/OrderMethodIcon';
import classnames from 'classnames';
import { DeliveryProvider, OrderMethod } from '../../../../types/constants';

type Props = {
  data: Server.OrderData;
} & WithClassname;

export default function OrderDetails({ data, className }: Props) {
  return (
    <div className={className}>
      <h1 className="mt-sm">Order #{data.fulfillment.number}</h1>
      <div className="mt-sm">
        <StorePreview id={data.company.uuid} data={data.company} />
        <h6 className="mt-sm">
          <UserOutlined className="mr-xs text-md" />
          {`${data.customer_first_name ?? ''} ${data.customer_last_name ?? ''}`.trim()}
          {' / '}
          <ClickToCopy>{data.customer_phone_number}</ClickToCopy>
        </h6>
        <h6 className="mt-sm">
          <OrderMethodIcon
            orderMethod={data.method}
            deliveryProvider={data.delivery_provider}
            className={classnames('mr-xs text-md', {
              '!text-lg':
                data.method === OrderMethod.Delivery &&
                data.delivery_provider !== DeliveryProvider.Standalone,
            })}
          />
          <span className="uppercase">{data.method}</span>
          {': '}
          {OrderHelpers.formatPickupTime(data.fulfillment.estimated_pickup_time)}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${data.company.web_shop_url}/order-details/${data.uuid}`}
            className="ml-xs font-normal text-sm text-[#1677ff]"
          >
            Open order tracking page
          </a>
        </h6>
      </div>

      <div className="grid grid-cols-4 gap-xl relative">
        <OrderItemsList data={data.line_items} className="col-span-3 mt-md" />
        <div className="bg-gray-50 sticky top-sm h-fit p-sm rounded-md max-h-[calc(100vh-24px)] overflow-y-auto">
          <h6 className="uppercase">Payment details</h6>
          <OrderPaymentBreakdown data={data} className="mt-sm" />
        </div>
      </div>
    </div>
  );
}
